import { render, staticRenderFns } from "./Classifier.vue?vue&type=template&id=f2f50e06&scoped=true&"
import script from "./Classifier.vue?vue&type=script&lang=js&"
export * from "./Classifier.vue?vue&type=script&lang=js&"
import style0 from "./Classifier.vue?vue&type=style&index=0&id=f2f50e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f50e06",
  null
  
)

export default component.exports